'use strict';

import angular from 'angular';

const menuServices = angular.module('applicationModule.menuServices', []);


menuServices.factory('Menu', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {

    const API_URL = AppsoupAPI.API_URL + '/menu/';

    return {
        getList: function (appId, clientId) {
            const url = API_URL + (angular.isDefined(clientId) ? 'client-permitted/' + clientId : '');

            return $http.get(url, {params: {application_id: appId}}).then(function (response) {
                return response.data;
            });
        },
        get: function (id) {
            return $http.get(API_URL + id);
        },
        save: function (menu, editMode) {
            if (editMode) {
                return $http.put(API_URL + menu.id, menu);
            } else {
                return $http.post(API_URL, menu);
            }
        },
        remove: function (id) {
            return $http.delete(API_URL + id);
        },
        changeOrder: function (data) {
            const url = API_URL + 'change-order/';

            return $http.post(url, data);
        }
    };
}]);

export default menuServices;
